import { AtlasKeyMetricV2PageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasKeyMetricV2PageLayout';
import { AtlasV2MicroTrendsListPageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2MicroTrendsListPageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasKeyMetricsV2PageLayout({ metricType }) {
  const keyMetricsPageLayout = {
    all: AtlasKeyMetricV2PageLayout,
    microtrends: AtlasV2MicroTrendsListPageLayout
  };

  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'keyMetricsV2PageLayout',
        CustomComponent: keyMetricsPageLayout[metricType],
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
